// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconSearch.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconSearch = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M12.6085 11.0578C13.4936 9.90222 14.0356 8.46222 14.0356 6.89778C14.0356 3.09333 10.8744 0 7.00875 0C3.1431 0 0 3.09333 0 6.89778C0 10.7022 3.1431 13.7956 7.00875 13.7956C8.45385 13.7956 9.80864 13.3511 10.9286 12.6044C10.9467 12.6222 10.9467 12.6222 10.9647 12.64L14.0356 15.6622C14.2523 15.8756 14.5594 16 14.8484 16C15.1375 16 15.4445 15.8933 15.6613 15.6622C16.1129 15.2178 16.1129 14.5067 15.6613 14.0622L12.6085 11.0578ZM7.00875 11.5378C4.40756 11.5378 2.2941 9.45778 2.2941 6.89778C2.2941 4.33778 4.40756 2.25778 7.00875 2.25778C9.60993 2.25778 11.7234 4.33778 11.7234 6.89778C11.7234 9.45778 9.60993 11.5378 7.00875 11.5378Z" />
  </BaseIcon>
);

export default IconSearch;
